import React, { Component } from "react"
import {FormTable} from './FormTable'
import { auth, db } from '../../../service';

export class Form extends Component {

    constructor(props) {
        super(props)
        this.state = {
            datas: [],
            easy: [],
            hard: [],
            medium: [],
        }
        this.getData=this.getData.bind(this)

    }
    componentDidMount(){
        this.getData()
    }
    componentDidUpdate(prevProps){
        if (this.props.match.params != prevProps.match.params) {
            this.getData()
        }

    }
    getData(){
        const { dare } = this.props.match.params
        const easy = []
        const hard = []
        const medium = []
        db.collection('dares').doc('lts').get().then((querySnapshot) => {
            const data = querySnapshot.data()[dare]
            for(var i=0; i<data['hard'].length; i++){
                hard.push(data['hard'][i])
            }
            for(var i=0; i<data['easy'].length; i++){
                easy.push(data['easy'][i])
            }
            for(var i=0; i<data['medium'].length; i++){
                medium.push(data['medium'][i])
            }
            this.setState({hard, easy, medium})
        }).catch((error) => {
            alert(error)
        })
    }
    render() {
        const { dare } = this.props.match.params

        const {datas, easy, hard, medium} = this.state
        return (
            <div className="main-content">
                <div className="my-4">
                    <div id="example_wrapper" className="">
                    <h5>Суга</h5>
                        <table className="table example" id="example">
                            <thead>
                                <tr>
                                    <th scope="col">Дугаар</th>
                                    <th scope="col">Шийтгэл</th>
                                    <th scope="col">Засах</th >
                                    <th scope="col">Устгах</th >
                                </tr>
                            </thead>
                            <tbody>
                                {easy.map((data, idx) =>
                                    <FormTable key = {idx} values={data}></FormTable>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <h5>Дундаж</h5>
                        <table className="table example" id="example">
                            <thead>
                                <tr>
                                    <th scope="col">Дугаар</th>
                                    <th scope="col">Шийтгэл</th>
                                    <th scope="col">Засах</th >
                                    <th scope="col">Устгах</th >
                                </tr>
                            </thead>
                            <tbody>
                                {medium.map((data, idx) =>
                                    <FormTable key = {idx} values={data}></FormTable>
                                )}
                            </tbody>
                        </table>
                    <h5>Аймар</h5>
                        <table className="table example" id="example">
                            <thead>
                                <tr>
                                    <th scope="col">Дугаар</th>
                                    <th scope="col">Шийтгэл</th>
                                    <th scope="col">Засах</th >
                                    <th scope="col">Устгах</th >
                                </tr>
                            </thead>
                            <tbody>
                                {hard.map((data, idx) =>
                                    <FormTable key = {idx} values={data}></FormTable>
                                )}
                            </tbody>
                        </table>
                </div>
            </div>
        )

    }

}
